import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api.ts';

interface Props {
  repoId: string;
  sourceSha: string;
  onClose: () => void;
}

export function CherryPickModal({ repoId, sourceSha, onClose }: Props) {
  const qc = useQueryClient();
  const [targetSha, setTargetSha] = useState('');
  const [note, setNote] = useState('');

  const mutation = useMutation({
    mutationFn: () =>
      api.createCherryPick({ repoId, sourceSha, targetSha, note: note || undefined }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['graph', repoId] });
      onClose();
    },
  });

  return (
    <div
      className="modal-backdrop"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      onKeyDown={(e) => { if (e.key === 'Escape') onClose(); }}
    >
      <div className="modal">
        <h2>Nouveau lien cherry-pick</h2>
        <p>
          Source : <code>{sourceSha.slice(0, 8)}</code>
        </p>
        <label className="col" style={{ gap: 4 }}>
          <span>Commit cible (SHA complet ou court)</span>
          <input value={targetSha} onChange={(e) => setTargetSha(e.target.value)} />
        </label>
        <label className="col" style={{ gap: 4, marginTop: 8 }}>
          <span>Note (optionnel)</span>
          <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
        </label>
        <div className="row" style={{ marginTop: 12, justifyContent: 'flex-end' }}>
          <button className="secondary" onClick={onClose}>
            Annuler
          </button>
          <button
            disabled={targetSha.length < 7 || mutation.isPending}
            onClick={() => mutation.mutate()}
          >
            Créer le lien
          </button>
        </div>
        {mutation.isError && (
          <p className="badge error">Erreur : {(mutation.error as Error).message}</p>
        )}
      </div>
    </div>
  );
}
